module.exports = __webpack_public_path__ + "img/20250528.b534db46.png";